import React, { useEffect, useState } from "react";
import { db } from "../firebase";
import {
  collection,
  getDocs,
  deleteDoc,
  doc,
} from "firebase/firestore";


function AdminDeletedWithdrawHistory() {
  const [transactions, setTransactions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [deletingId, setDeletingId] = useState(null);
  const [searchUser, setSearchUser] = useState("");

  useEffect(() => {
    const fetchTransactions = async () => {
      setLoading(true);
      try {
        const tshSnap = await getDocs(collection(db, "tsh_transactions"));
        const usdtSnap = await getDocs(collection(db, "usdt_transactions"));

        const combined = [
          ...tshSnap.docs.map((doc) => ({
            id: doc.id,
            ...doc.data(),
            collection: "tsh_transactions",
          })),
          ...usdtSnap.docs.map((doc) => ({
            id: doc.id,
            ...doc.data(),
            collection: "usdt_transactions",
          })),
        ];

        combined.sort((a, b) => {
          const aTime = a.timestamp?.seconds || 0;
          const bTime = b.timestamp?.seconds || 0;
          return bTime - aTime;
        });

        setTransactions(combined);
      } catch (error) {
        console.error("Error fetching transactions:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchTransactions();
  }, []);

  const deleteTransaction = async (id, collectionName) => {
    if (!window.confirm("Una uhakika unataka kufuta transaction hii?")) return;
    setDeletingId(id);
    try {
      await deleteDoc(doc(db, collectionName, id));
      setTransactions((prev) => prev.filter((tx) => tx.id !== id));
    } catch (error) {
      console.error("Error deleting transaction:", error);
    } finally {
      setDeletingId(null);
    }
  };

  // Prioritize searched username
  const filteredTransactions = transactions
    .filter((tx) => {
      const user = (tx.username || tx.fullName || "").toLowerCase();
      return user.includes(searchUser.toLowerCase());
    })
    .concat(
      transactions.filter(
        (tx) =>
          !(tx.username || tx.fullName || "")
            .toLowerCase()
            .includes(searchUser.toLowerCase())
      )
    );

  return (
    <div className="admin-transactions">
      <h2>Admin - Delete Withdraw Transactions</h2>

      <input
        type="text"
        placeholder="Tafuta kwa username..."
        value={searchUser}
        onChange={(e) => setSearchUser(e.target.value)}
        style={{
          width: "100%",
          padding: "10px",
          marginBottom: "20px",
          borderRadius: "5px",
          fontSize: "16px",
        }}
      />

      {loading ? (
        <p>Inapakia...</p>
      ) : (
        <table className="admin-transactions-table">
          <thead>
            <tr>
              <th>Tarehe</th>
              <th>Username</th>
              <th>Metoda</th>
              <th>Kiasi</th>
              <th>TXID</th>
              <th>Status</th>
              <th>Futa</th>
            </tr>
          </thead>
          <tbody>
            {filteredTransactions.map((tx) => (
              <tr key={tx.id}>
                <td>
                  {tx.timestamp?.seconds
                    ? new Date(tx.timestamp.seconds * 1000).toLocaleString()
                    : "-"}
                </td>
                <td>{tx.username || tx.fullName || "N/A"}</td>
                <td>{tx.collection === "tsh_transactions" ? "TSH" : "USDT"}</td>
                <td>{tx.amount?.toLocaleString() || 0}</td>
                <td>{tx.txId || "-"}</td>
                <td>{tx.status || "-"}</td>
                <td>
                  <button
                    onClick={() => deleteTransaction(tx.id, tx.collection)}
                    disabled={deletingId === tx.id}
                    style={{
                      background: "red",
                      color: "white",
                      border: "none",
                      padding: "5px 10px",
                      cursor: "pointer",
                      borderRadius: "5px",
                    }}
                  >
                    {deletingId === tx.id ? "Inafuta..." : "Futa"}
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
}

export default AdminDeletedWithdrawHistory;